import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { SearchTabs } from './SearchTabs';

const PageTitle = () => (
  <Box textAlign="center">
    <div style={{ marginBottom: 12 }}>
      <h1 style={{
        fontSize: '2.2rem',
        fontWeight: 700,
        margin: 0,
        letterSpacing: '-0.02em',
        lineHeight: 1.2,
        color: '#0f1b2a',
      }}>
        Beacon Lookup
      </h1>
    </div>
    <Box variant="p" fontSize="heading-s" color="text-body-secondary">
      End-to-end payment visibility across the last-mile pipeline
    </Box>
  </Box>
);

export const SearchPage = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      minHeight: 'calc(100vh - 56px)',
      paddingTop: '12vh',
      padding: '12vh 24px 0',
    }}>
      <div style={{ maxWidth: 760, width: '100%' }}>
        <SpaceBetween size="xl">
          <PageTitle />
          <SearchTabs />
        </SpaceBetween>
      </div>
    </div>
  );
};
